import { formatToRelativeTime, toCalendarTime, toTime } from './dateFormatService';
import type { DateInput } from './dateFormatService';

export type DateFormatType = 'relative' | 'calendar' | 'combined' | 'timeCombined';

export function formatDate(date: DateInput, formatType: DateFormatType, locale: string): string {
  switch (formatType) {
    case 'relative':
      return formatToRelativeTime(date, locale);
    case 'calendar':
      return toCalendarTime(date, locale);
    case 'combined':
      return `${toCalendarTime(date, locale)}, ${formatToRelativeTime(date, locale)}`;
    case 'timeCombined':
      return `${toTime(date, locale)}, ${formatToRelativeTime(date, locale)}`;
  }
}
